module.exports = __webpack_public_path__ + "img/avatar-bril.514e8652.png";